import React, { Component } from "react";
import { message, Row, Col, Spin, } from "antd";
import { ButtonItem, ErrorItem, Form, FormItem,InputItem, InputNumberItem } from "../../../../Components/Items";
import axios from "axios";
import { connect } from "react-redux";
import DynamicCardForm from "../../../../Components/DynamicCardForm";


class DireccionConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    archivo: null,
    base64: null,
    archivosLogo: [],
    persona: false,
    loading: false
  };
  componentDidMount() {
    this.consultarConfiguracion();
  }
  onFinish(values) {
    this.setState({loading: true})
    axios
      .post(
        "empresas/editarConfiguracionAvanzado",
        {...values, empresaId: this.props.empresaId},
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({loading: false})
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuracion de la empresa");
          this.consultarConfiguracion();
        } else if (res.data.success === 1) {
          message.error("No se pudo modificar la configuracion");
        } else {
          message.error("Hubo un error y no se modifico la configuracion");
        }
      });
  }
  async consultarConfiguracion() {
    this.setState({loading: true})
    await axios
      .post(
        "empresas/selectConfiguracionAvanzado",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro configuracion de esta empresa");
        } else {
            this.setState({persona: res.data.persona})
          this.formRef.current.setFieldsValue({
            ...res.data
          });
        }
      });
      this.setState({loading: false})
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  render() {
    return (
      <>
      <Spin spinning={this.state.loading}>
      <Form
          name="avanzadoConfiguracion"
          layout
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
          ref={this.formRef}
          loading={this.state.loading}
        >
         <DynamicCardForm
            title="Información"
            style={{
                maxWidth: '98%',   
                margin: '0 auto 12px auto' ,
            }}
          >
            <Row>
            <Col span={12}>
            {this.state.persona ? null : (
                <FormItem
                  label="Curp"
                  name="curp"
                  curp
                  max={200}
                  min={5}
                  margin
                >
                  <InputItem placeholder="Clave Unica de Registro de Poblacion" />
                </FormItem>
              )}
              <FormItem label="Telefono" name="telefono" number margin>
                <InputNumberItem placeholder="Telefono" celular />
              </FormItem>
              <FormItem
                label="Correo"
                name="correo"
                pattern
                max={200}
                email
                margin
              >
                <InputItem placeholder="Correo" />
              </FormItem>
              <FormItem
                label="Pagina Web"
                name="paginaWeb"
                pattern
                max={200}
                margin
              >
                <InputItem placeholder="Pagina Web" />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem
                label="Nombre Contacto"
                name="nombreContacto"
                pattern
                max={200}
                margin
              >
                <InputItem placeholder="Nombre de Contacto" />
              </FormItem>
              <FormItem
                label="Telefono Contacto"
                name="telefonoContacto"
                number
                margin
              >
                <InputNumberItem placeholder="Telefono de Contacto" celular />
              </FormItem>
              <FormItem
                label="Correo Contacto"
                name="correoContacto"
                pattern
                max={200}
                email
                margin
              >
                <InputItem placeholder="Correo de Contacto" />
              </FormItem>        
            </Col>
          </Row>
          </DynamicCardForm>
          <DynamicCardForm  
            title="Bancos"
             style={{
                maxWidth: '98%',   
                margin: '0 auto 12px auto' ,
            }}
          >
          <Row>
            <Col span={12}>
              <FormItem name="banco" label="Banco" margin pattern>
                <InputItem placeholder="Banco" />
              </FormItem>
              <FormItem
                label="Cuenta Banco"
                name="cuentaBanco"
                number
                max={20}
                margin
              >
                <InputItem placeholder="Cuenta de Banco" />
              </FormItem>
              <FormItem
                label="Cuenta Clabe"
                name="cuentaClabe"
                number
                max={20}
                min={18}
                margin
              >
                <InputItem placeholder="Cuenta Clabe" />
              </FormItem>
              <FormItem
                label="Swift Code"
                name="swiftCode"
                max={11}
                min={8}
                margin
              >
                <InputItem placeholder="Swift Code" />
              </FormItem>
              <FormItem
                label="ABA Code"
                name="abaCode"
                max={9}
                min={9}
                margin
              >
                <InputItem placeholder="ABA Code" />
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem name="banco2" label="Banco 2" margin pattern>
                <InputItem placeholder="Banco 2" />
              </FormItem>
              <FormItem
                label="Cuenta Banco 2"
                name="cuentaBanco2"
                number
                max={20}
                margin
              >
                <InputItem placeholder="Cuenta de Banco" />
              </FormItem>
              <FormItem
                label="Cuenta Clabe 2"
                name="cuentaClabe2"
                number
                max={20}
                min={18}
                margin
              >
                <InputItem placeholder="Cuenta Clabe" />
              </FormItem>
              <FormItem
                label="Swift Code 2"
                name="swiftCode2"
                max={11}
                min={8}
                margin
              >
                <InputItem placeholder="Swift Code 2" />
              </FormItem>
              <FormItem
                label="ABA Code 2"
                name="abaCode2"
                max={9}
                min={9}
                margin
              >
                <InputItem placeholder="ABA Code 2" />
              </FormItem>
            </Col>
          </Row>
          </DynamicCardForm>
           <div style={{display: 'flex', justifyContent: 'flex-end',padding: '12px 8px',borderTop: '1px solid #f0f0f0',flexShrink: 0}}>
                <ButtonItem
                    cyan
                    type="primary"
                    htmlType="submit"
                    style={{
                        minWidth: 120,
                        height: 30,
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    Guardar Configuración
                </ButtonItem>
            </div>
        </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(DireccionConfiguracion);
